import * as libFund from './fund';
import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
export const prefix = 'quantifiedVotes';
export const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ fundID, quantifiedVoteID }) => {
    return libFund.IDToName({ fundID }) + SEPARATOR + prefixWithSeparator + quantifiedVoteID;
};
export const validateName = genericValidateName([
    exactValidator(libFund.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split(SEPARATOR);
    return {
        fundID: parts[1],
        quantifiedVoteID: parts[3],
    };
};
